import { inject } from 'inversify';

import { service } from '@/decorators/service';
import { SignalrListener, SignalrMessage } from '@/decorators/signalr';
import { Configuration } from '@/entities/Configuration';
import { Logger } from '@/services/Logger';
import { ConfigurationsReqMsg } from '@/services/signalr/MessageTypes/Configuration';
import { Signalr } from '@/services/signalr/Signalr';
import { ConfigurationStore } from '@/stores/ConfigurationStore';
import { IConfigurationInfo } from '~/api/IConfigurationInfo';
import { IConfigurationMsg } from '~/api/messages/IConfigurationMsg';
import { IConfigurationUpdateRespMsg } from '~/api/messages/IConfigurationUpdateRespMsg';
import { IConfigurationsRespMsg } from '~/api/messages/IConfigurationsRespMsg';
import { IDispatchMessage } from '~/api/messages/IDispatchMessage';

@SignalrListener
@service(ConfigurationManager)
export class ConfigurationManager {
  @inject(Logger) protected logger: Logger;
  @inject(Signalr) protected signalr: Signalr;
  @inject(ConfigurationStore) protected configurationStore: ConfigurationStore;

  async load() {
    await this.signalr.invoke(ConfigurationsReqMsg);
  }

  get all(): Configuration[] {
    return this.configurationStore.all();
  }

  find(name: string) {
    return this.all.find((c) => c.field === name) as Configuration;
  }

  @SignalrMessage('ConfigurationsRespMsg')
  async onConfigurationsRespMsg(configurations: IConfigurationsRespMsg & IDispatchMessage) {
    this.update(configurations.configurationInfos);
  }

  @SignalrMessage('ConfigurationUpdateRespMsg')
  async onConfigurationUpdateRespMsg(configuration: IConfigurationUpdateRespMsg & IDispatchMessage) {
    this.update([configuration.configuration]);
  }

  @SignalrMessage('ConfigurationMsg')
  async onConfigurationMsg(configurationMsg: IConfigurationMsg & IDispatchMessage) {
    this.update(configurationMsg.configurationInfos);
  }

  update(configurationInfos: IConfigurationInfo[]) {
    this.configurationStore.batchUpdate(configurationInfos as Configuration[]);
  }
}
